import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiShortListModel } from '../models/api-list.model';
import { ReferenceZoneModel } from '../models/reference-zone.model';

@Injectable({
  providedIn: 'root',
})
export class ReferenceZonesService {
  constructor(public _apiService: ApiService) {}

  getList(): Observable<ReferenceZoneModel[]> {
    return this._apiService
      .get<ApiShortListModel<ReferenceZoneModel>>('reference-zones')
      .pipe(
        map((zoneList: ApiShortListModel<ReferenceZoneModel>) => zoneList.value)
      );
  }
}
